import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 404-Seite fuer unbekannte Routen.
 */
function NotFoundPage(): React.JSX.Element {
  return (
    <div
      id="not-found-page"
      className="d-flex flex-column align-items-center justify-content-center min-vh-100 px-3 text-center"
    >
      <i
        id="not-found-icon"
        className="bi bi-signpost-split text-primary"
        style={{ fontSize: '3rem' }}
      ></i>
      <h1 id="not-found-heading" className="page-heading h3 mt-3 mb-2">
        Seite nicht gefunden
      </h1>
      <p id="not-found-text" className="text-muted mb-4">
        Die angeforderte Seite existiert nicht.
      </p>
      {/*
       * Ein Element, eine ID: Link in Button-Optik statt Button-in-Link.
       * `<Button as={Link}>` ist mit react-bootstrap 2.10 nicht typsicher
       * moeglich (das `as` von @restart/ui erlaubt nur intrinsische Tags),
       * daher der bewusst gewaehlte Link mit `btn btn-primary`.
       */}
      <Link to="/" id="not-found-home-button" className="btn btn-primary">
        <i className="bi bi-house me-2" id="not-found-home-icon"></i>
        Zum Dashboard
      </Link>
    </div>
  );
}

export default NotFoundPage;
